<template>
  <ul class="author-list">
    <li>
      <div class="author-img">
        <img src="../../assets/img/user.png">
      </div>
      <div class="cont">
        <p class="nick">格隆汇</p>
        <p class="email">华人海外投资的交流平台，邮箱：business@gelonghui.com</p>
        <p class="email">华人海外投资的交流平台，邮箱：business@gelonghui.com</p>
        <p class="email">华人海外投资的交流平台，邮箱：business@gelonghui.com</p>
      </div>
      <div class="care">删除</div>
    </li>
    <li>
      <div class="author-img">
        <img src="../../assets/img/user.png">
      </div>
      <div class="cont">
        <p class="nick">格隆汇</p>
        <p class="email">华人海外投资的交流平台</p>
      </div>
      <div class="care">删除</div>
    </li>
  </ul>
</template>
<script>
export default {
  //   name: "App",
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style scoped>
.author-list {
  width: 100%;
  margin-top: 15px;
}
.author-list li {
  min-height: 100px;
  padding: 30px 15px 25px;
}
.author-list li:hover {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
}
.author-list li .cont {
  width: calc(100% - 150px);
}
.author-list li .care {
  line-height: 30px;
}
</style>